import * as React from 'react';
export const microsoftpaySvg = React.forwardRef(function microsoftpaySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M14.483 8.83c.032.102.057.224.075.364h.01c.016-.103.046-.223.088-.359l.513-1.66H16l-1.104 2.938c-.266.706-.667 1.059-1.202 1.059-.203 0-.37-.023-.502-.07v-.668a.707.707 0 0 0 .365.098.455.455 0 0 0 .45-.305l.144-.338-1.104-2.714h.93l.506 1.654ZM2.956 11.05H0V8.094h2.956v2.956Zm3.252 0H3.252V8.094h2.956v2.956Zm5.737-3.941c.776 0 1.164.386 1.164 1.16v1.626h-.794v-.39h-.01a.887.887 0 0 1-.81.456c-.265 0-.473-.075-.625-.224-.15-.15-.225-.35-.225-.6 0-.527.312-.832.937-.913l.738-.099c0-.297-.161-.446-.483-.446-.324 0-.633.097-.925.29v-.632c.117-.06.277-.114.479-.16.203-.046.388-.068.554-.068ZM9.432 6.086c.96 0 1.44.405 1.44 1.214a1.17 1.17 0 0 1-.415.929c-.274.235-.642.353-1.103.353h-.408v1.313h-.858V6.086h1.344Zm2.394 2.584c-.273.036-.409.159-.409.37a.31.31 0 0 0 .099.236.39.39 0 0 0 .27.09.5.5 0 0 0 .386-.162.596.596 0 0 0 .148-.415v-.182l-.494.063Zm-2.88-.738h.337c.457 0 .686-.2.686-.6 0-.392-.229-.588-.686-.588h-.337v1.188Zm-5.99-.136H0V4.84h2.956v2.956Zm3.252 0H3.252V4.84h2.956v2.956Z',
    }),
  );
});
microsoftpaySvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var microsoftpay = {
  category: 'paymentmethod',
  colorable: true,
  name: 'microsoftpay',
  svg: microsoftpaySvg,
};
